import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove Emergent badge
const removeBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) {
    badge.remove();
  }
  // Also remove any elements with emergent in href
  document.querySelectorAll('a[href*="emergent"]').forEach(el => {
    if (el.textContent.includes('Made with') || el.textContent.includes('Emergent')) {
      el.remove();
    }
  });
};

// Run immediately and observe for dynamic additions
removeBadge();
const observer = new MutationObserver(removeBadge);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
